
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  onMounted,
  ref,
} from 'vue'
import { required } from '@/utils/rules'
import { editSetting, addSetting } from './api'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
    isType: {
      type: String,
      default: () => {},
    },
  },
  // emits: ['update:modelValue'],
  setup(props, { emit }) {
    const data = reactive({
      visible: false,
      titlename: '模型配置',
      formRef: undefined,
      formData: ref<any>({}),
      id: 0,
      rules: {
        name: [required],
        identification: [required],
        requestContent: [required],
        password: [required],
        status: [required],
      },
      isdisable: false,
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    /**
     * @description: 关闭dialog
     * @param {*} void
     * @return {*}
     */
    const onCancel = (): void => {
      data.visible = false
      emit('update:modelValue', false)
      emit('getListFn')
    }
    const init = () => {
      data.formData = props.row || []
      data.id = props.row.id || null
      if (props.isType === 'edit') {
        data.isdisable = true
      }
    }

    // 提交表单
    const handleSubmit = () => {
      data.formRef.validate(async (valid) => {
        if (valid) {
          const p: any = {
            ...data.formData,
            id: data.id || 0,
          }
          if (props.isType === 'edit') {
            const [err] = await toResult(editSetting(p))
            if (err) return false
          } else {
            const [err] = await toResult(addSetting(p))
            if (err) return false
          }

          ElMessage.success('操作成功')
          onCancel()
        }
      })
    }

    onMounted(() => {
      init()
    })
    return {
      ...toRefs(data),
      handleSubmit,
      onCancel,
      init,
    }
  },
})
